import React, { Fragment, useState, useEffect } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import { reduxForm } from "redux-form";
import { withTranslation } from "react-i18next";
import PrintIcon from "@material-ui/icons/Print";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import FileDownloadIcon from "@material-ui/icons/CloudDownload";
import Spinner from "react-bootstrap/Spinner";
import ElectronicBillingHTTP from "../../../../ElectronicBilling/api/ElectronicBillingHTTP";
import TalummHTTP from "../../../../ElectronicBilling/api/TalummHTTP";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faFilePdf,
  faGlobe,
  faFileInvoice,
  faFileInvoiceDollar,
  faMoneyCheckDollar,
  faCalendarAlt,
  faClipboardList,
  faEnvelopeOpenText,
} from "@fortawesome/free-solid-svg-icons";
import GenerateExcelQuerysAndProcedures from "./GenerateExcelQuerysAndProcedures";
import GeneratePDFQuerysAndProcedures from "./GeneratePDFQuerysAndProcedures";
import GenerateExcelReportServices from "./GenerateExcelReportServices";
import GeneratePDFReportServices from "./GeneratePDFReportServices";
import { InvoiceUtils } from "./InvoiceUtils";
import ModalTemplatePdf from "./ModalTemplatePDF";
import AlertModal from "../../../../../shared/components/Modal";
import CloseIcon from "@material-ui/icons/Close";
import SettingsEthernetIcon from "@material-ui/icons/SettingsEthernet";
import Modal from "@material-ui/core/Modal";
import SwapVerticalCircleIcon from "@material-ui/icons/SwapVerticalCircle";
import history from "../../../../../history";
import AddPaymentToInvoice from "./AddPaymentToInvoice";
import MoneyOffIcon from "@material-ui/icons/MoneyOff";
import AddRetentionToInvoice from "../../../../Retention/components/RetentionTypes/AddRetentionType";
import FormAddRetention from "../../../../Retention/components/FormAddRetention";
import FacturaTechHTTP from "../../../../ElectronicBilling/api/FacturaTechHTTP";
import CreditNoteVerificationModal from "./CreditNoteVerificationModal";
import PartialCreditNote from "./PartialCreditNote";
import ModalDatesInvoice from "./ModalDatesInvoice";
import IconButtonDetailSurcharge from "./IconButtonDetailSurcharge";
import IFacturaAppHTTP from "../../../../ElectronicBilling/api/IFacturaAppHTTP";
import SendMailElectronicInvoice from "./sendMailELectronicInvoice/SendMailElectronicInvoice";
import { da } from "date-fns/locale";

const ReactTableActions = ({
  data,
  Callback,
  fechaInicial,
  fechaFinal,
  loadBilling,
  retentionsTypeList = [],
  electronicInvoiceProvider,
  costumers = [],
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [invoiceLoadingXML, setinvoiceLoadingXML] = useState(false);
  const [invoiceLoadingPDF, setinvoiceLoadingPDF] = useState(false);
  const [invoiceElectronicProcess, setInvoiceElectronicProcess] =
    useState(false);
  const [loadingExcelQuerysAndProcedures, setLoadingExcelQuerysAndProcedures] =
    useState(false);
  const [loadingPDFQuerysAndProcedures, setLoadingPDFQuerysAndProcedures] =
    useState(false);
  const [colorAlertModal, setColorAlertModal] = useState(false);
  const [messagAlerteModal, setMessagAlertModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState("");
  const [showAlertModalDelete, setAlertModalDelete] = useState(false);
  const [showAlertModalCreditNote, setAlertModalCreditNote] = useState(false);
  const [loadingExcelReportServices, setLoadingExcelReportServices] =
    useState(false);
  const [loadingPDFReportServices, setLoadingPDFReportServices] =
    useState(false);
  const [loadingCancelInvoice, setLoadingCancelInvoice] = useState(false);
  const [loadingAddCreditNote, setLoadingAddCreditNote] = useState(false);
  const [loadingShowCreditNote, setLoadingShowCreditNote] = useState(false);
  const [
    showAlertModalCreditNoteViewError,
    setShowAlertModalCreditNoteViewError,
  ] = useState(false);
  const [showModalPayments, setShowModalPayments] = useState(false);
  const [showModalRetentions, setShowModalRetentions] = useState(false);
  const [anulationReceiptsInCreditNote, setAnulationReceiptsInCreditNote] =
    useState(false);
  const [modalAnulationReceiptsNC, setModalAnulationReceiptsNC] =
    useState(false);
  const [modalPartialCreditNote, setModalPartialCreditNote] = useState(false);
  const [openModalDatesInvoice, setOpenModalDatesInvoice] = useState(false);
  const [openModalSendMail, setOpenModalSendMail] = useState(false);
  const [mailCostumer, setMailCostumer] = useState("");

  useEffect(() => {
    verifyAnulationReceiptsNC();
    defineCostumerEmail();
  }, []);

  const verifyAnulationReceiptsNC = () => {
    let clinica = JSON.parse(sessionStorage.getItem("clinica"));
    setAnulationReceiptsInCreditNote(clinica.anulacion_recibos_nota);
  };

  const defineCostumerEmail = () => {
    if (costumers.length) {
      let customerByThisInvoice = costumers.find(
        (third) =>
          third.id_tercero ===
          parseInt(data?.data?.original.id_tercero ?? data.id_tercero)
      );
      if (customerByThisInvoice) {
        if (customerByThisInvoice.correo) {
          setMailCostumer(customerByThisInvoice.correo);
        }
      }
    }
  };

  const downloadXml = async (data) => {
    let factura = {
      prefijo: data.split("-")[0],
      folio: data.split("-")[1],
    };

    switch (electronicInvoiceProvider.id_factura_electronica_api) {
      case 1: //Factura Tech
        await XMLFtech(data, factura);
        break;
      case 2: //Talumm
        await XMLTalumm(data, factura);
        break;
      case 3: //iFacturaApp
        await XMLiFacturaApp(data);
        break;
    }
  };

  const XMLTalumm = async (data, factura) => {
    await TalummHTTP.downloadXML(data, factura);
  };

  const XMLiFacturaApp = async (data, factura) => {
    await IFacturaAppHTTP.downloadXMLiFacturaApp(data, factura);
  };

  const alertModal = (type, message) => {
    setColorAlertModal(type);
    setMessagAlertModal(message);
    setShowAlertModal(true);
  };

  const XMLFtech = async (data, factura) => {
    await fetch(
      `${process.env.REACT_APP_PUBLIC_URL}factura-electronica/download-xml-file`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(factura),
      }
    )
      .then((res) => res.blob())
      .then((blob) => {
        const a = document.createElement("a");
        a.setAttribute("download", "archivo-" + data + ".xml");
        a.setAttribute("href", window.URL.createObjectURL(blob));
        a.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const downloadPdf = async (data) => {
    switch (electronicInvoiceProvider.id_factura_electronica_api) {
      case 1: //Factura Tech
        downloadPDF64Ftech(data);
        break;
      case 2: //Talumm
        await TalummHTTP.downloadPDF(data);
        break;
      case 3: //iFacturaApp
        await IFacturaAppHTTP.downloadPDFiFacturaApp(data);
        break;
    }
  };

  const downloadPDF64Ftech = async (data) => {
    let factura = {
      prefijo: data.split("-")[0],
      folio: data.split("-")[1],
    };

    await fetch(
      `${process.env.REACT_APP_PUBLIC_URL}factura-electronica/download-pdf-file`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(factura),
      }
    )
      .then((res) => res.blob())
      .then((blob) => {
        const a = document.createElement("a");
        a.setAttribute("download", "documento-" + data + ".pdf");
        a.setAttribute("href", window.URL.createObjectURL(blob));
        a.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const printPdf = async () => {
    switch (data?.data?.original.factura_tipo_fe ?? data.factura_tipo_fe) {
      case "CUENTA DE COBRO": //Cuentas de Cobro generadas a los Clientes
        await printInternalHealthInvoice();
        break;
      case "FACTURA EN SALUD": //Facturas Generadas a partir de un Recibo de Caja por Cita Medica
        await printInternalHealthInvoice();
        break;
      case "FACTURA COMERCIAL": //Facturas Generadas a traves del Facturador
        await printInternalComercialInvoice();
        break;
    }
  };

  const printInternalComercialInvoice = async () => {
    setOpenModal(true);
    let InvoiceUt = new InvoiceUtils();
    await InvoiceUt.getComercialInvoice(
      data?.data?.original.id_factura_t ?? data.id_factura_t
    );
  };

  const printInternalHealthInvoice = async () => {
    let InvoiceUt = new InvoiceUtils();
    let idsReceipts = InvoiceUt.extractIdForReceipts(
      data?.data?.original ?? data
    );
    await InvoiceUt.getReceiptsById(
      idsReceipts,
      data?.data?.original.id_tercero ?? data.id_tercero,
      data?.data?.original.num_fac_ter ?? data.num_fac_ter,
      data?.data?.original.folio_nota_credito ?? data.folio_nota_credito
    )
      .then((res) => {
        if (res != null) {
          setOpenModal(true);
          if (res.factura.recibosCaja.length > 1) {
            InvoiceUt.generatePDFPrevisualizationInvoices(
              res.factura,
              data?.data?.original.es_factura ?? data.es_factura
            );
          } else {
            InvoiceUt.generatePDFPrevisualization(
              res.factura,
              data?.data?.original.es_factura ?? data.es_factura
            );
          }
        } else {
          console.log("Error consultando la Previsualizacion de la Factura");
        }
      })
      .catch((error) => {
        alertModal(
          "danger",
          "Ha ocurrido un error previsualizando la Factura, es posible que se hallan facturado diferentes contratos"
        );
        setOpenModal(false);
        console.log(error);
      });
  };

  const getDataInvoiceVerifyQuerysAndProcedures = async (optFile) => {
    switch (optFile) {
      case 1: //Excel
        setLoadingExcelQuerysAndProcedures(true);
        break;
      case 2: //PDF
        setLoadingPDFQuerysAndProcedures(true);
        break;
      case 3: // Excel Gama
        setLoadingExcelReportServices(true);
        break;
      case 4: // PDF Gama
        setLoadingPDFReportServices(true);
        break;
    }

    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "factura-excel/verificar/" +
        (data?.data?.original.id_factura_t ?? data.id_factura_t),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        openFileInvoiceQueryAndProcedures(optFile, res);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const calculatePaymentsDetails = (data) => {
    let details = {
      valor_servicio_item: 0,
      valor_copago_item: 0,
      valor_neto_item: 0,
    };
    for (let i = 0; i < data.length; i++) {
      details.valor_servicio_item =
        parseInt(details.valor_servicio_item) +
        parseInt(data[i].valor_servicio_item);
      details.valor_copago_item =
        parseInt(details.valor_copago_item) +
        parseInt(data[i].valor_copago_item);
      details.valor_neto_item =
        parseInt(details.valor_neto_item) + parseInt(data[i].valor_neto_item);
    }
    return details;
  };

  const openFileInvoiceQueryAndProcedures = (optFile, invoiceDetails) => {
    let paymentsDetails = calculatePaymentsDetails(invoiceDetails);
    switch (optFile) {
      case 1: //Excel
        setLoadingExcelQuerysAndProcedures(false);
        GenerateExcelQuerysAndProcedures.exportExcel(
          invoiceDetails,
          data?.data?.original ?? data
        );
        break;
      case 2: //PDF
        setLoadingPDFQuerysAndProcedures(false);
        setOpenModal(true);
        GeneratePDFQuerysAndProcedures(
          invoiceDetails,
          data?.data?.original ?? data
        );
        break;
      case 3: //Excel2
        setLoadingExcelReportServices(false);
        GenerateExcelReportServices.exportExcel(
          invoiceDetails,
          data?.data?.original ?? data
        );
        break;
      case 4: //PDF2
        setLoadingPDFReportServices(false);
        setOpenModal(true);
        GeneratePDFReportServices(
          invoiceDetails,
          paymentsDetails,
          fechaInicial,
          fechaFinal
        );
        break;

      default:
        alertModal("danger", "Opcion de Documento no Disponible");
        break;
    }
  };

  const attemptAgainElectronicBilling = async (options) => {
    const {
      recibo_caja,
      id_factura,
      consecutivo,
      charge,
      viewOnly = false,
    } = options;
    switch (data?.data?.original.factura_tipo_fe ?? data.factura_tipo_fe) {
      case "CUENTA DE COBRO": //Cuentas de Cobro generadas a los Clientes
        alert("No se puede transmitir una cuenta de cobro");
        break;
      case "FACTURA EN SALUD": //Facturas Generadas a partir de un Recibo de Caja por Cita Medica
        await transmitionHealthInvoice(
          recibo_caja,
          id_factura,
          consecutivo,
          charge,
          viewOnly
        );
        break;
      case "FACTURA COMERCIAL": //Facturas Generadas a traves del Facturador
        await transmitionComercialInvoice(
          id_factura,
          consecutivo,
          charge,
          viewOnly
        );
        break;
    }
  };

  const transmitionComercialInvoice = async (
    id_factura,
    consecutivo,
    charge,
    viewOnly = false
  ) => {
    setInvoiceElectronicProcess(true);
    let providerElectronicInvoice =
      await ElectronicBillingHTTP.getActualProvider();
    switch (parseInt(providerElectronicInvoice.id_factura_electronica_api)) {
      case 1: //Facturatech
        await fetch(
          process.env.REACT_APP_PUBLIC_URL +
            "facturas/get-comercial-invoice?id_factura_t=" +
            (data?.data?.original.id_factura_t ?? data.id_factura_t),
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
          .then((response) => {
            if (response.status != 500 && response.status != 403) {
              return response.json();
            } else {
              throw new Error("Data");
            }
          })
          .then((res) => {
            FacturaTechHTTP.generateXMLInvoice(
              res.factura,
              "COMERTIAL",
              data?.data?.original.id_factura_t ?? data.id_factura_t,
              "INVOICE",
              viewOnly
            )
              .then((success) => {
                if (success == true) {
                  alertModal("success", "Factura Emitida correctamente");
                } else {
                  alertModal(
                    "danger",
                    "Ha ocurrido un error transmitiendo la Factura"
                  );
                }
                setInvoiceElectronicProcess(false);
              })
              .catch((error) => {
                console.log(error);
                alertModal(
                  "danger",
                  "Ha ocurrido un error transmitiendo la Factura"
                );
                setInvoiceElectronicProcess(false);
              });
          })
          .catch((error) => {
            console.log(error);
            alertModal(
              "danger",
              "Ha ocurrido un error con la Facturación Electronica"
            );
            setInvoiceElectronicProcess(false);
            
          });
        break;
      case 2: //Talumm
        await TalummHTTP.importComercialInvoice(id_factura)
          .then((response_invoice) => {
            if (response_invoice != null) {
              if (
                response_invoice.code == "00" ||
				response_invoice.code == "200" ||
				response_invoice.code == "201" ||
                response_invoice.code == "203"
              ) {
                alertModal(
                  "success",
                  "Facturacion Electronica Generada correctamente"
                );
                setInvoiceElectronicProcess(false);
              } else {
                throw new Error("Error de Validaciones en la Factura");
              }
            } else {
              throw new Error("No se genero el JSON");
            }
          })
          .catch((error) => {
            setInvoiceElectronicProcess(false);
            console.error("Error:", error);
            alertModal(
              "danger",
              "Ha ocurrido un error con la Facturación Electronica"
            );
          });
        break;
      case 3: //iFacturaApp
        await IFacturaAppHTTP.importComercialInvoiceiFacturaApp(id_factura)
          .then((response_invoice) => {
            console.log("response_invoice", response_invoice);
            if (response_invoice != null) {
              if (
                response_invoice.statuCode == 200 ||
                response_invoice.statuCode == 203
              ) {
                alertModal(
                  "success",
                  "Facturacion Electronica Generada correctamente"
                );
                setInvoiceElectronicProcess(false);
              } else {
                throw new Error(response_invoice.message_api);
              }
            } else {
              throw new Error("No se genero el JSON");
            }
          })
          .catch((error) => {
            setInvoiceElectronicProcess(false);
            console.error({ error, error: typeof error });
            alertModal("danger", error.toString());
          });
        break;
    }
  };

  const transmitionHealthInvoice = async (
    recibo_caja,
    id_factura,
    consecutivo,
    charge,
    viewOnly = false
  ) => {
    setInvoiceElectronicProcess(true);
    let providerElectronicInvoice =
      await ElectronicBillingHTTP.getActualProvider();
    switch (parseInt(providerElectronicInvoice.id_factura_electronica_api)) {
      case 1: //--------------------------------Facturatech--------------------------------------------------
        let InvoiceUt = new InvoiceUtils();
        let idsReceipts = InvoiceUt.extractIdForReceipts(
          data?.data?.original ?? data
        );
        await InvoiceUt.getReceiptsById(
          idsReceipts,
          data?.data?.original.id_tercero ?? data.id_tercero,
          data?.data?.original.num_fac_ter ?? data.num_fac_ter,
          data?.data?.original.folio_nota_credito ?? data.folio_nota_credito
        )
          .then((invoiceData) => {
            FacturaTechHTTP.generateXMLInvoice(
              invoiceData.factura,
              "SALUD",
              data?.data?.original.id_factura_t ?? data.id_factura_t,
              "INVOICE",
              viewOnly
            )              
              .then((success) => {
                if (success == true) {
                  alertModal(
                    "success",
                    "Facturación Electronica Generada correctamente"
                  );
                  console.log("datafactura tech", data, invoiceData.factura, viewOnly)
                } else {
                  alertModal(
                    "danger",
                    "Ha ocurrido un error transmitiendo la Factura Electronica"
                  );
                }
                setInvoiceElectronicProcess(false);
              })
              .catch((error) => {
                alertModal("danger", "Ha ocurrido un error en el Sistema");
                console.log(error);
                setInvoiceElectronicProcess(false);
              });
          })
          .catch((error) => {
            console.log(error);
            alertModal(
              "danger",
              "Ha ocurrido un error con la Facturación Electronica"
            );
            setInvoiceElectronicProcess(false);
          });
        break;
      case 2: //--------------------------------Talumm--------------------------------------------------
        await TalummHTTP.importInvoice(id_factura)
          .then((response_invoice) => {
            if (response_invoice != null) {
              if (
                response_invoice.code == "00" ||
				response_invoice.code == "200" ||
				response_invoice.code == "201" ||
                response_invoice.code == "203"
              ) {
                alertModal(
                  "success",
                  "Facturacion Electronica Generada correctamente"
                );
                setInvoiceElectronicProcess(false);
              } else {
                throw new Error("Error de Validaciones en la Factura");
              }
            } else {
              throw new Error("No se genero el JSON");
            }
          })
          .catch((error) => {
            setInvoiceElectronicProcess(false);
            console.error("Error:", error);
            alertModal(
              "danger",
              "Ha ocurrido un error con la Facturación Electronica"
            );
          });
        break;
      case 3: //--------------------------------iFacturaApp--------------------------------------------------
        await IFacturaAppHTTP.importInvoiceiFacturaApp(id_factura)
          .then((response_invoice) => {
            console.log("response_invoice", response_invoice);
            if (response_invoice != null) {
              if (
                response_invoice.statuCode == 200 ||
                response_invoice.statuCode == 203
              ) {
                alertModal(
                  "success",
                  "Facturacion Electronica Generada correctamente"
                );
                setInvoiceElectronicProcess(false);
              } else {
                throw new Error("Error de Validaciones en la Factura");
              }
            } else {
              throw new Error("No se genero el JSON");
            }
          })
          .catch((error) => {
            setInvoiceElectronicProcess(false);
            console.error("Error:", error);
            alertModal(
              "danger",
              "Ha ocurrido un error con la Facturación Electronica"
            );
          });
        break;
    }
  };

  const closeAlertModal = () => {
    if (colorAlertModal == "success") {
      Callback();
    }
    setShowAlertModal(false);
    setColorAlertModal("info");
    setMessagAlertModal("");
  };

  const cancelInvoice = async () => {
    setAlertModalDelete(false);
    setLoadingCancelInvoice(true);
    let dataSend = {
      id_factura_t: data?.data?.original.id_factura_t ?? data.id_factura_t,
    };
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "facturas/cancelar-factura",
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error cancelando la Factura");
        }
      })
      .then((res) => {
        setLoadingCancelInvoice(false);
        setColorAlertModal("success");
        setMessagAlertModal(
          "La Factura " + data?.data?.original.num_fac_ter ??
            data.num_fac_ter + " se ha Eliminado Correctamente"
        );
        setShowAlertModal(true);
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoadingCancelInvoice(false);
      });
  };

  const generarNotaCredito = async () => {
    setLoadingAddCreditNote(true);
    setAlertModalCreditNote(false);

    let providerElectronicInvoice =
      await ElectronicBillingHTTP.getActualProvider();
    switch (parseInt(providerElectronicInvoice.id_factura_electronica_api)) {
      case 1: //Facturatech
        let InvoiceUt = new InvoiceUtils();
        let idsReceipts = InvoiceUt.extractIdForReceipts(
          data?.data?.original ?? data
        );

        if (
          data?.data?.original.factura_tipo_fe ??
          data.factura_tipo_fe == "FACTURA EN SALUD"
        ) {
          //Factura en Salud
          await InvoiceUt.getReceiptsById(
            idsReceipts,
            data?.data?.original.id_tercero ?? data.id_tercero,
            data?.data?.original.num_fac_ter ?? data.num_fac_ter,
            data?.data?.original.folio_nota_credito ?? data.folio_nota_credito
          )
            .then((invoiceData) => {
              FacturaTechHTTP.generateXMLInvoice(
                invoiceData.factura,
                "SALUD",
                data?.data?.original.id_factura_t ?? data.id_factura_t,
                "NC"
              )
                .then((success) => {
                  if (success == true) {
                    alertModal(
                      "success",
                      "Nota Crédito Generada correctamente"
                    );
                  } else {
                    alertModal(
                      "danger",
                      "Ha ocurrido un error transmitiendo la Nota Crédito"
                    );
                  }
                  setLoadingAddCreditNote(false);
                })
                .catch((error) => {
                  alertModal("danger", "Ha ocurrido un error en el Sistema");
                  console.log(error);
                  setLoadingAddCreditNote(false);
                });
            })
            .catch((error) => {
              console.log(error);
              alertModal(
                "danger",
                "Ha ocurrido un error generando la Nota Crédito"
              );
              setLoadingAddCreditNote(false);
            });
        } else {
          //Factura Comercial
          await fetch(
            process.env.REACT_APP_PUBLIC_URL +
              "facturas/get-comercial-invoice?id_factura_t=" +
              data?.data?.original.id_factura_t ?? data.id_factura_t,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            }
          )
            .then((response) => {
              if (response.status != 500 && response.status != 403) {
                return response.json();
              } else {
                throw new Error("Data");
              }
            })
            .then((res) => {
              FacturaTechHTTP.generateXMLInvoice(
                res.factura,
                "COMERTIAL",
                data?.data?.original.id_factura_t ?? data.id_factura_t,
                "NC"
              )
                .then((success) => {
                  if (success == true) {
                    alertModal("success", "Nota Crédito Emitida correctamente");
                  } else {
                    alertModal(
                      "danger",
                      "Ha ocurrido un error transmitiendo la Nota Crédito"
                    );
                  }
                  setLoadingAddCreditNote(false);
                })
                .catch((error) => {
                  console.log(error);
                  alertModal(
                    "danger",
                    "Ha ocurrido un error transmitiendo la Nota Crédito"
                  );
                  setLoadingAddCreditNote(false);
                });
            })
            .catch((error) => {
              console.log(error);
              throw new Error(
                "Ha ocurrido un error transmitiendo la Nota Crédito"
              );
            });
        }
        break;
      default: //Talumm & iFacturaApp
        let dataSend = {
          id_factura_t: data?.data?.original.id_factura_t ?? data.id_factura_t,
        };
        await fetch(
          process.env.REACT_APP_PUBLIC_URL +
            "factura-electronica/generar-nota-credito",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: "Bearer " + sessionStorage.getItem("token"),
            },
            body: JSON.stringify(dataSend),
          }
        )
          .then((response) => {
            if (response.status != 500 && response.status != 403) {
              return response.json();
            } else {
              throw new Error(
                "Ha ocurrido un error generando la Nota Credito de la Factura"
              );
            }
          })
          .then((res) => {
            setAlertModalCreditNote(false);
            setLoadingAddCreditNote(false);
            setColorAlertModal("success");
            setMessagAlertModal(
              "Se ha Generado la Nota Crédito de la Factura " +
                data?.data?.original.num_fac_ter ?? data.num_fac_ter
            );
            setShowAlertModal(true);
          })
          .catch((error) => {
            console.error("Error:", error);
            setAlertModalCreditNote(false);
            setLoadingAddCreditNote(false);
            setColorAlertModal("danger");
            setMessagAlertModal(
              "Ha ocurrido un error generando la Nota Crédito"
            );
            setShowAlertModal(true);
          });
        break;
    }
  };

  const visualizarNotaCredito = async () => {
    setLoadingShowCreditNote(true);
    let providerElectronicInvoice =
      await ElectronicBillingHTTP.getActualProvider();
    switch (parseInt(providerElectronicInvoice.id_factura_electronica_api)) {
      case 1: //Factura Tech
        await fetch(
          `${process.env.REACT_APP_PUBLIC_URL}factura-electronica/pdf-nota-credito-ftech`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: "Bearer " + sessionStorage.getItem("token"),
            },
            body: JSON.stringify({
              id_factura_t:
                data?.data?.original.id_factura_t ?? data.id_factura_t,
            }),
          }
        )
          .then((res) => res.blob())
          .then((blob) => {
            setLoadingShowCreditNote(false);
            setOpenModal(true);
            document.getElementById("pdfV").src =
              window.URL.createObjectURL(blob);
          })
          .catch((err) => {
            setLoadingShowCreditNote(false);
            setOpenModal(false);
            setShowAlertModalCreditNoteViewError(true);
            console.log(err);
          });
        break;
      case 2: //Talum
        await fetch(
          `${
            process.env.REACT_APP_PUBLIC_URL
          }factura-electronica/revisar-url-nota-credito?id_factura_t=${
            data?.data?.original.id_factura_t ?? data.id_factura_t
          }`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
          .then((response) => {
            if (response.status != 500 && response.status != 403) {
              return response.json();
            } else {
              throw new Error(
                "Error de Conexion con el Proveedor de Facturación Electronica"
              );
            }
          })
          .then((data) => {
            setLoadingShowCreditNote(false);
            setOpenModal(true);
            document.getElementById("pdfV").src = data.url_nota;
          })
          .catch((err) => {
            setLoadingShowCreditNote(false);
            setOpenModal(false);
            setShowAlertModalCreditNoteViewError(true);
            console.log(err);
          });
        break;
      case 3: //iFacturaApp
        await IFacturaAppHTTP.downloadPDFNCSiFacturaApp(
          data?.data?.original.folio_nota_credito ?? data.folio_nota_credito
        );
        setLoadingShowCreditNote(false);
        break;
      default:
        alert("Sin proveedor de Factura Electronica");
        break;
    }
  };

  const generarJsonRips = async (num_fac_ter, id_tercero) => {
    const clinica = JSON.parse(sessionStorage.getItem("clinica"));
    if (clinica && num_fac_ter && id_tercero) {
      const dataToGetRip = {
        id_clinica: clinica.id_clinica,
        id_tercero,
        num_fac_ter,
      };

      try {
        const response = await fetch(
          process.env.REACT_APP_PUBLIC_URL +
            "rips/generar-archivo-transacciones-json",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: "Bearer " + sessionStorage.getItem("token"),
            },
            body: JSON.stringify(dataToGetRip),
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();

        const jsonString = JSON.stringify(responseData, null, 2);

        const blob = new Blob([jsonString], { type: "text/plain" });

        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = `rips-${num_fac_ter}.json`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <Fragment>
      <td role="cell" className="button-action-react-table">
        <Tooltip
          className="icon-action-elmt"
          title="Generar Excel Consultas/Procedimientos"
        >
          {loadingExcelQuerysAndProcedures ? (
            <Spinner
              style={{ width: "24px", height: "24px" }}
              animation="border"
              variant="success"
            />
          ) : (
            <span>
              <IconButton
                aria-label="print"
                disabled={
                  !(data?.data?.original.factura_salud ?? data.factura_salud)
                }
                style={{ padding: 2 }}
                onClick={() => {
                  getDataInvoiceVerifyQuerysAndProcedures(1);
                }}
              >
                <FontAwesomeIcon icon={faFileExcel} />
              </IconButton>
            </span>
          )}
        </Tooltip>
        <Tooltip
          className="icon-action-elmt"
          title="Generar PDF Consultas/Procedimientos"
        >
          {loadingPDFQuerysAndProcedures ? (
            <Spinner
              style={{ width: "24px", height: "24px" }}
              animation="border"
              variant="success"
            />
          ) : (
            <span>
              <IconButton
                aria-label="print"
                disabled={
                  !(data?.data?.original.factura_salud ?? data.factura_salud)
                }
                style={{ padding: 2 }}
                onClick={() => {
                  getDataInvoiceVerifyQuerysAndProcedures(2);
                }}
              >
                <FontAwesomeIcon icon={faFilePdf} />
              </IconButton>
            </span>
          )}
        </Tooltip>

        <IconButtonDetailSurcharge
          data={data}
          id_factura_t={data?.data?.original.id_factura_t ?? data.id_factura_t}
        />

        <Tooltip
          className="icon-action-elmt"
          title="Cambiar Fecha de Emisión y/o Vencimiento"
        >
          <span>
            <IconButton
              aria-label="print"
              disabled={
                data?.data?.original.cufe ?? data.cufe == null ? false : true
              }
              style={{ padding: 2 }}
              onClick={() => {
                setOpenModalDatesInvoice(true);
              }}
            >
              <FontAwesomeIcon icon={faCalendarAlt} />
            </IconButton>
          </span>
        </Tooltip>

        <Tooltip className="icon-action-elmt" title="Descargar XML">
          {invoiceLoadingXML ? (
            <Spinner
              style={{ width: "24px", height: "24px" }}
              animation="border"
              variant="success"
            />
          ) : (
            <span>
              <IconButton
                disabled={
                  invoiceLoadingPDF ||
                  invoiceLoadingXML ||
                  (data?.data?.original.cufe ?? data.cufe) == null
                    ? true
                    : false
                }
                aria-label="consult-credit-data"
                style={{ padding: 2 }}
                onClick={() => {
                  setinvoiceLoadingXML(true);
                  downloadXml(
                    data?.data?.original.num_fac_ter ?? data.num_fac_ter
                  )
                    .then(() => {
                      setinvoiceLoadingXML(false);
                    })
                    .catch(() => {
                      setinvoiceLoadingXML(false);
                    });
                }}
              >
                <FileDownloadIcon />
              </IconButton>
            </span>
          )}
        </Tooltip>
        <Tooltip className="icon-action-elmt" title="Pdf Dian">
          {invoiceLoadingPDF ? (
            <Spinner
              style={{ width: "24px", height: "24px" }}
              animation="border"
              variant="success"
            />
          ) : (
            <span>
              <IconButton
                disabled={
                  invoiceLoadingPDF ||
                  invoiceLoadingXML ||
                  (data?.data?.original.cufe ?? data.cufe) == null
                    ? true
                    : false
                }
                aria-label="print"
                style={{ padding: 2 }}
                onClick={() => {
                  setinvoiceLoadingPDF(true);
                  downloadPdf(
                    data?.data?.original.num_fac_ter ?? data.num_fac_ter
                  )
                    .then(() => {
                      setinvoiceLoadingPDF(false);
                    })
                    .catch(() => {
                      setinvoiceLoadingPDF(false);
                    });
                }}
              >
                <PictureAsPdfIcon />
              </IconButton>
            </span>
          )}
        </Tooltip>
        <Tooltip className="icon-action-elmt" title="Imprimir Previsualización">
          <IconButton
            aria-label="print"
            style={{ padding: 2 }}
            onClick={() => {
              printPdf();
            }}
          >
            <PrintIcon />
          </IconButton>
        </Tooltip>
        <Tooltip
          className="icon-action-elmt"
          title="Transmitir Facturación Electronica"
        >
          {invoiceElectronicProcess ? (
            <Spinner
              style={{ width: "24px", height: "24px" }}
              animation="border"
              variant="success"
            />
          ) : (
            <span>
              <IconButton
                /* disabled={
                  (data?.data?.original.cufe ?? data.cufe != null) ||
                  (data?.data?.original.es_factura ?? data.es_factura) == false
                    ? true
                    : false
                } */
                aria-label="print"
                style={{ padding: 2 }}
                onClick={() => {
                  attemptAgainElectronicBilling({
                    recibo_caja: null,
                    id_factura:
                      data?.data?.original.id_factura_t ?? data.id_factura_t,
                    consecutivo: null,
                    charge: null,
                    viewOnly:
                      (data?.data?.original.cufe ?? data.cufe != null) ||
                      (data?.data?.original.es_factura ?? data.es_factura) ==
                        false
                        ? true
                        : false,
                  });
                }}
              >
                <FontAwesomeIcon
                  icon={faGlobe}
                  style={{
                    color:
                      (data?.data?.original.cufe ?? data.cufe != null) /*||
                       (data?.data?.original.es_factura ?? data.es_factura) ==
                        false */
                        ? "#28a745"
                        : "#6c757d",
                  }}
                />
              </IconButton>
            </span>
          )}
        </Tooltip>
        <Tooltip className="icon-action-elmt" title="Eliminar Factura">
          {loadingCancelInvoice ? (
            <Spinner
              style={{ width: "24px", height: "24px" }}
              animation="border"
              variant="success"
            />
          ) : (
            <span>
              <IconButton
                disabled={
                  data?.data?.original.cufe ?? data.cufe != null ? true : false
                }
                aria-label="print"
                style={{ padding: 2 }}
                onClick={() => {
                  setAlertModalDelete(true);
                }}
              >
                <CloseIcon />
              </IconButton>
            </span>
          )}
        </Tooltip>

        <Tooltip
          className="icon-action-elmt"
          title="Crear Retenciones a la Factura"
        >
          <IconButton
            aria-label="print"
            style={{ padding: 2 }}
            onClick={() => {
              setShowModalRetentions(true);
            }}
          >
            <MoneyOffIcon />
          </IconButton>
        </Tooltip>

        <Tooltip className="icon-action-elmt" title="Generar Pago a la Factura">
          <IconButton
            aria-label="print"
            style={{ padding: 2 }}
            onClick={() => {
              setShowModalPayments(true);
            }}
          >
            <SwapVerticalCircleIcon />
          </IconButton>
        </Tooltip>

        {anulationReceiptsInCreditNote == true ? (
          <Tooltip
            className="icon-action-elmt"
            title="Generar Nota Crédito Completa"
          >
            {loadingAddCreditNote ? (
              <Spinner
                style={{ width: "24px", height: "24px" }}
                animation="border"
                variant="success"
              />
            ) : (
              <span>
                <IconButton
                  disabled={
                    (data?.data?.original.cufe ?? data.cufe) != null &&
                    loadingAddCreditNote == false &&
                    (data?.data?.original.folio_nota_credito ??
                      data.folio_nota_credito) == null
                      ? false
                      : true
                  }
                  aria-label="print"
                  style={{ padding: 2 }}
                  onClick={() => {
                    setAlertModalCreditNote(true);
                  }}
                >
                  <FontAwesomeIcon icon={faFileInvoice} />
                </IconButton>
              </span>
            )}
          </Tooltip>
        ) : null}

        {anulationReceiptsInCreditNote == false ? (
          <>
            <Tooltip className="icon-action-elmt" title="Generar Nota Crédito">
              <span>
                <IconButton
                  disabled={
                    (data?.data?.original.cufe ?? data.cufe) != null &&
                    (data?.data?.original.folio_nota_credito ??
                      data.folio_nota_credito) == null
                      ? false
                      : true
                  }
                  aria-label="print"
                  style={{ padding: 2 }}
                  onClick={() => {
                    setModalAnulationReceiptsNC(true);
                  }}
                >
                  <FontAwesomeIcon icon={faFileInvoice} />
                </IconButton>
              </span>
            </Tooltip>
          </>
        ) : null}

        <Tooltip className="icon-action-elmt" title="Visualizar Nota Crédito">
          {loadingShowCreditNote ? (
            <Spinner
              style={{ width: "24px", height: "24px" }}
              animation="border"
              variant="success"
            />
          ) : (
            <span>
              <IconButton
                disabled={
                  (data?.data?.original.folio_nota_credito ??
                    data.folio_nota_credito) == null
                    ? true
                    : false
                }
                aria-label="print"
                style={{ padding: 2 }}
                onClick={() => {
                  visualizarNotaCredito(null);
                }}
              >
                <FontAwesomeIcon icon={faFileInvoiceDollar} />
              </IconButton>
            </span>
          )}
        </Tooltip>

        <Tooltip className="icon-action-elmt" title="Generar JSON">
          {loadingShowCreditNote ? (
            <Spinner
              style={{ width: "24px", height: "24px" }}
              animation="border"
              variant="success"
            />
          ) : (
            <span>
              <IconButton
                aria-label="print"
                style={{ padding: 2 }}
                onClick={() => {
                  generarJsonRips(
                    data?.data?.original.num_fac_ter ?? data.num_fac_ter,
                    data?.data?.original.id_tercero ?? data.id_tercero
                  );
                }}
              >
                <SettingsEthernetIcon color="black" />
              </IconButton>
            </span>
          )}
        </Tooltip>

        {(data?.data?.original.tipo ?? data.tipo) != 1 &&
          (data?.data?.original.cufe ?? data.cufe) != null && (
            <Tooltip className="icon-action-elmt" title="Nota Credito Parcial">
              <span>
                <IconButton
                  aria-label="print"
                  disabled={
                    data?.data?.original.folio_nota_credito ??
                    data.folio_nota_credito
                  }
                  style={{ padding: 2 }}
                  onClick={() => {
                    setModalPartialCreditNote(true);
                  }}
                >
                  <FontAwesomeIcon icon={faMoneyCheckDollar} />
                </IconButton>
              </span>
            </Tooltip>
          )}

        {(electronicInvoiceProvider
          ? electronicInvoiceProvider.hasOwnProperty(
              "id_factura_electronica_api"
            )
            ? electronicInvoiceProvider.id_factura_electronica_api === 3
            : false
          : false) &&
          (data?.data?.original.cufe ?? data.cufe) && (
            <Tooltip
              className="icon-action-elmt"
              title="Enviar correo | Attachment Document"
            >
              <span>
                <IconButton
                  aria-label="print"
                  /* disabled={data?.data?.original.folio_nota_credito ?? data.folio_nota_credito} */
                  style={{ padding: 2 }}
                  onClick={() => {
                    setOpenModalSendMail(true);
                  }}
                >
                  <FontAwesomeIcon icon={faEnvelopeOpenText} />
                </IconButton>
              </span>
            </Tooltip>
          )}
      </td>

      <ModalTemplatePdf
        openModal={openModal}
        closeModal={() => setOpenModal(false)}
      />

      <AlertModal
        color={colorAlertModal}
        title={messagAlerteModal}
        modal={showAlertModal}
        onOk={() => {
          closeAlertModal();
        }}
        toggle={() => {
          closeAlertModal();
        }}
      />

      <AlertModal
        color={"warning"}
        title={"Esta seguro de eliminar la Factura?"}
        modal={showAlertModalDelete}
        message={
          "Al hacer esto, los Recibos de Caja y valores de los mismos quedaran nuevamente en Pendientes por Facturar"
        }
        onOk={() => {
          cancelInvoice();
        }}
        toggle={() => {
          setAlertModalDelete(false);
        }}
      />

      <AlertModal
        color={"warning"}
        title={"Esta seguro de hacer una Nota Crédito Completa a esta Factura?"}
        modal={showAlertModalCreditNote}
        message={
          "Al hacer esto, los Recibos de Caja y valores de los mismos quedaran nuevamente en Pendientes por Facturar y se generara la Nota Crédito de la Factura"
        }
        onOk={() => {
          generarNotaCredito();
        }}
        toggle={() => {
          setAlertModalCreditNote(false);
        }}
      />

      <AlertModal
        color={"warning"}
        title={"Error"}
        modal={showAlertModalCreditNoteViewError}
        message={
          "Ha ocurrido un error de Conexión con el Proveedor de Facturación Electronica"
        }
        onOk={() => {
          setShowAlertModalCreditNoteViewError(false);
        }}
        toggle={() => {
          setShowAlertModalCreditNoteViewError(false);
        }}
      />

      {loadingAddCreditNote == true ? (
        <>
          <Modal
            open={loadingAddCreditNote}
            onClose={() => {
              setLoadingAddCreditNote(false);
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
            disableEnforceFocus={true}
          >
            <div
              className="paperAppointment-flex"
              style={{
                borderColor: "white",
                boxShadow: "white",
                height: "300x",
                width: "30%",
                margin: 10,
              }}
            >
              <div className="text-center">
                <br />
                <br />
                <br />
                <div class="load__icon-wrap">
                  <svg class="load__icon">
                    <path
                      fill="#4ce1b6"
                      d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                    />
                  </svg>
                </div>
                <br />
                <br />
                <br />
              </div>
            </div>
          </Modal>
        </>
      ) : null}

      {showModalPayments == true ? (
        <Fragment>
          <Modal
            open={showModalPayments}
            onClose={() => {
              setShowModalPayments(false);
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
            disableEnforceFocus={true}
          >
            {/* <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '300x', width: '80%', margin: 10 }}> */}
            <AddPaymentToInvoice
              selectedInvoice={data?.data?.original ?? data}
            />
            {/* </div> */}
          </Modal>
        </Fragment>
      ) : null}

      {showModalRetentions == true ? (
        <Fragment>
          <Modal
            open={showModalRetentions}
            onClose={() => {
              setShowModalRetentions(false);
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
            disableEnforceFocus={true}
          >
            <div
              className="paperAppointment-flex"
              style={{
                borderColor: "white",
                boxShadow: "white",
                height: "300x",
                width: "80%",
                margin: 10,
              }}
            >
              <FormAddRetention
                selectedInvoice={data?.data?.original ?? data}
                retentionsTypeList={retentionsTypeList}
              />
            </div>
          </Modal>
        </Fragment>
      ) : null}

      {anulationReceiptsInCreditNote == false &&
      modalAnulationReceiptsNC == true ? (
        <>
          <CreditNoteVerificationModal
            opened={modalAnulationReceiptsNC}
            closeModal={() => {
              setModalAnulationReceiptsNC(false);
            }}
            closeModalFinish={() => {
              setModalAnulationReceiptsNC(false);
              Callback();
            }}
            id_factura_t={
              data?.data?.original.id_factura_t ?? data.id_factura_t
            }
            num_fac_ter={data?.data?.original.num_fac_ter ?? data.num_fac_ter}
            providerFE={electronicInvoiceProvider}
            invoiceType={
              data?.data?.original.factura_tipo_fe ?? data.factura_tipo_fe
            }
            invoice={data?.data?.original ?? data}
          />
        </>
      ) : null}

      {modalPartialCreditNote == true ? (
        <PartialCreditNote
          opened={modalPartialCreditNote}
          closeModal={() => {
            setModalPartialCreditNote(false);
          }}
          closeModalFinish={() => {
            setModalPartialCreditNote(false);
            Callback();
          }}
          id_factura_t={data?.data?.original.id_factura_t ?? data.id_factura_t}
          num_fac_ter={data?.data?.original.num_fac_ter ?? data.num_fac_ter}
          providerFE={electronicInvoiceProvider}
        />
      ) : null}

      {openModalDatesInvoice == true ? (
        <ModalDatesInvoice
          opened={openModalDatesInvoice}
          closeModal={() => {
            setOpenModalDatesInvoice(false);
          }}
          closeModalConfirm={() => {
            setOpenModalDatesInvoice(false);
            Callback();
          }}
          fechaEmision={
            data?.data?.original.fecha_emision ?? data.fecha_emision
          }
          fechaVencimiento={
            data?.data?.original.vencimiento ?? data.vencimiento
          }
          numFacTer={data?.data?.original.num_fac_ter ?? data.num_fac_ter}
          idFactura={data?.data?.original.id_factura_t ?? data.id_factura_t}
        />
      ) : null}

      {openModalSendMail == true ? (
        <Fragment>
          <Modal
            open={openModalSendMail}
            onClose={() => {
              setOpenModalSendMail(false);
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
            disableEnforceFocus={true}
          >
            <div
              className="paperAppointment-flex"
              style={{
                borderColor: "white",
                boxShadow: "white",
                height: "300x",
                width: "80%",
                margin: 10,
              }}
            >
              <SendMailElectronicInvoice
                selectedInvoice={data?.data?.original ?? data}
                mailCostumer={mailCostumer}
                setOpenModalSendMail={setOpenModalSendMail}
              />
            </div>
          </Modal>
        </Fragment>
      ) : null}
    </Fragment>
  );
};

export default ReactTableActions;
